import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Loader from '../Loader/Loader.js';

import { StyledText } from '../../atoms/Text/StyledText.js';
import { StyledTrackHours } from '../../atoms/TrackHours/StyledTrackHours.js';
import { StyledGlobalScrollWrapper, StyledLoaderWrapper } from '../../../styles/sharedStyles.js';

import { listStudents, listSubjects } from '../../../logic/requests/students.js';
import { getLang, getString } from '../../../strings/index.js';
import { cebulaCompare } from '../../../logic/arrays.js';

import { hasPermission } from '../../../logic/permissions.js';
import AddHourForm from './AddHourForm.js';
import TrackManagerHours from './TrackManagerHours.js';

const UserPanelTrainerAddHours = ({ user }) => {
    const [students, setStudents] = useState();
    const [subjects, setSubjects] = useState();
    const [err, setErr] = useState(false);
    const navigate = useNavigate();



    useEffect(() => {
        if (!(user && hasPermission(user, 'can_add_hours')))
            navigate('/my-account', { replace: true });

        listStudents()
            .then((res) => {
                setStudents(
                    res.sort(
                        (a, b) =>
                            cebulaCompare(a.lastname, b.lastname) ||
                            cebulaCompare(a.firstname, b.firstname)
                    )
                );
            })
            .catch((err) => {
                console.error('listStudents', err);
                setErr(true);
                setStudents([]);
            });

        listSubjects()
            .then((res) => {
                setSubjects(
                    res
                        .filter((el) => el.description)
                        .sort((a, b) =>
                            cebulaCompare(a.description[getLang()], b.description[getLang()])
                        )
                );
            })
            .catch((err) => {
                console.error('listSubjects', err);
                setErr(true);
                setSubjects([]);
            });
    }, [navigate, user]);

    return (
        <StyledTrackHours>
            <StyledGlobalScrollWrapper>
                {!(students && subjects) ? (
                    <StyledLoaderWrapper>
                        <Loader />
                    </StyledLoaderWrapper>
                ) : !(students.length && subjects.length) ? (
                    <StyledLoaderWrapper>
                        <StyledText
                            hasdeclaredpadding="0px 20px"
                            hasdeclaredfontsize="22px"
                            hasdeclaredfontweight="700"
                            hasdeclaredtextalign="center"
                            hasdeclaredlineheight="1.4em"
                            as="p"
                        >
                            {getString(
                                err
                                    ? 'blad_wczytywania'
                                    : 'UserPanelTrainer__no_students_or_subjects'
                            )}
                        </StyledText>
                    </StyledLoaderWrapper>
                ) : (
                    <AddHourForm user={user} students={students} subjects={subjects} />
                )}
                {(hasPermission(user, 'can_have_manager_hours_and_access_own_hours') ||
                    hasPermission(user, 'can_manage_all_manager_hours')) && (
                    <>
                        <TrackManagerHours user={user} />
                    </>
                )}
            </StyledGlobalScrollWrapper>
        </StyledTrackHours>
    );
};

export default UserPanelTrainerAddHours;
